import type { Course } from "@/modules/courses/entities/courses"
import { create, type StateCreator } from "zustand"

interface UseSelectedCourseState {
  selectedCourse: Course | null
  setSelectedCourse: (course: Course | null) => void
  resetSelectedCourse: () => void
}

const state: StateCreator<UseSelectedCourseState> = (set) => ({
  selectedCourse: null,
  setSelectedCourse: (course) => set({ selectedCourse: course }),
  resetSelectedCourse: () => set({ selectedCourse: null }),
})

export const useSelectedCourse = create<UseSelectedCourseState>(state)
